import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { num } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";

const LogRow = ({ l }) => {
  const qc = useQueryClient();
  const del = useMutation({
    mutationFn: async () => api.delete(`/cutting/logs/${l.id}`),
    onSuccess: () => { ["cutting", "materials"].forEach((k) => qc.invalidateQueries({ queryKey: [k] })); toast.success("Taglio eliminato"); },
  });
  return (
    <TableRow data-testid={`cut-log-row-${l.id}`}>
      <TableCell className="text-sm">{l.date.split("-").reverse().join("/")}</TableCell>
      <TableCell>
        {l.items.map((i) => <p key={`${i.product_id}-${i.queue_id}`} className="text-sm">{i.product_name} <span className="text-muted-foreground">· {i.color} · {i.sizes.map((s) => `${s.size}×${s.quantity}`).join(" ")}</span></p>)}
        {l.sample && <Badge variant="outline" className="mt-1 border-sky-500/50 text-[10px] text-sky-400">Campione</Badge>}
      </TableCell>
      <TableCell className="text-right text-sm font-semibold">{num(l.pieces)}</TableCell>
      <TableCell className="text-right text-sm">{num(l.markers)}</TableCell>
      <TableCell className="text-right text-sm">{num(l.fabric_meters)} m{l.material_name && <span className="block text-[11px] text-muted-foreground">{l.material_name}</span>}</TableCell>
      <TableCell className="text-sm">{l.cutter}</TableCell>
      <TableCell><Button size="icon" variant="ghost" className="h-8 w-8" onClick={() => window.confirm("Eliminare questo taglio?") && del.mutate()} data-testid={`cut-log-delete-${l.id}`}><Trash2 className="h-4 w-4" /></Button></TableCell>
    </TableRow>
  );
};

export const CuttingLogs = ({ logs }) => (
  <Card className="p-6" data-testid="cutting-logs">
    <h3 className="mb-4 font-display text-lg font-semibold">Registro tagli</h3>
    <div className="max-h-[480px] overflow-auto">
      <Table>
        <TableHeader><TableRow className="hover:bg-transparent"><TableHead>Data</TableHead><TableHead>Articoli</TableHead><TableHead className="text-right">Capi</TableHead><TableHead className="text-right">Grafici</TableHead><TableHead className="text-right">Tessuto</TableHead><TableHead>Tagliato da</TableHead><TableHead /></TableRow></TableHeader>
        <TableBody>
          {logs.map((l) => <LogRow key={l.id} l={l} />)}
          {logs.length === 0 && <TableRow><TableCell colSpan={7} className="py-8 text-center text-sm text-muted-foreground">Nessun taglio nel periodo.</TableCell></TableRow>}
        </TableBody>
      </Table>
    </div>
  </Card>
);
